@if (username) {
    @if (isVisible == undefined) {
        <loading [isLoading]="true" [success]="true"></loading>
    } @else if (isVisible) {
        <div class="flex flex-col sm:flex-row gap-2 justify-center">
            <!-- Nav -->
            <div class="flex flex-col text-sm p-2 sm:pt-4">
                <div class="bg-slate-100 rounded-md shadow w-full sm:w-64">
                    <div class="bg-ponder-light rounded-t-md p-2 pr-8 text-slate-50 text-base shadow">
                        Collection Stats
                    </div>
                    <user-stat-category-button label="General" [category]="statsCategories.CollectionGeneral" [isSelected]="true"></user-stat-category-button>
                    <user-stat-category-button label="Game: Magic" [category]="statsCategories.CollectionGameMagic" [isLast]="true"></user-stat-category-button>
                </div>
            </div>
            <!-- Display -->
            <div class="flex flex-col w-[360px] sm:min-w-[360px] sm:max-w-[720px] grow">
                <user-collection-general-stats [username]="username" [statsCategory]="statsCategories.CollectionGeneral" [selectedCategory]="selectedCategory"></user-collection-general-stats>
                <user-collection-magic-stats [username]="username" [statsCategory]="statsCategories.CollectionGameMagic" [selectedCategory]="selectedCategory"></user-collection-magic-stats>
            </div>
        </div>
    } @else {
        <div class="flex flex-col items-center justify-center">
            <div class="flex flex-col gap-1 w-[360px] bg-slate-100 rounded shadow-sm p-8 text-slate-600 text-center text-sm italic">
                Collection statistics for this user are private.
            </div>
        </div>
    }
}